import { render, staticRenderFns } from "./PriceCards.vue?vue&type=template&id=4a6961f6&scoped=true&"
import script from "./PriceCards.vue?vue&type=script&lang=ts&"
export * from "./PriceCards.vue?vue&type=script&lang=ts&"
import style0 from "./PriceCards.vue?vue&type=style&index=0&id=4a6961f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6961f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
